<div class="wrapper flex flex-col justify-between" [formGroup]="form">
  <div class="details flex-1">
    <ng-container *ngIf="isOrgAdmin; else basicFieldsView">
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['item']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="item"
        label="Item"
      />
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['quantity']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="quantity"
        label="Quantity"
      />
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['uom']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="uom"
        label="UOM"
      />
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['unit_price']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="unit_price"
        label="Unit price"
      />
      <app-text-area
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['description']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="description"
        label="Description"
      />
    </ng-container>
    <ng-template #basicFieldsView>
      <app-view-field class="w-full mb-[40px]" [required]="true" [value]="form?.controls?.item?.value" label="Item" />
      <app-view-field class="w-full mb-[40px]" [required]="true" [value]="form?.controls?.quantity?.value" label="Quantity" />
      <app-view-field class="w-full mb-[40px]" [required]="true" [value]="form?.controls?.uom?.value" label="UOM" />
      <app-view-field class="w-full mb-[40px]" [required]="true" [value]="form?.controls?.unit_price?.value" label="Unit price" />
      <app-view-field class="w-full mb-[40px]" [required]="true" [value]="form?.controls?.description?.value" label="Description" />
    </ng-template>

    <ng-container *ngIf="canEditOptions; else optionsView">
      <div *ngIf="isOrgAdmin" class="toggle-row mb-[40px]">
        <div class="label text-type-13 uppercase">Record by Station</div>
        <mat-slide-toggle formControlName="record_by_station" [disabled]="!canEditOptions" class="slide-toggle-btn" color="primary"></mat-slide-toggle>
      </div>
      <div class="toggle-row mb-[40px]">
        <div class="label text-type-13 uppercase">Rollup Qty Editable</div>
        <mat-slide-toggle formControlName="rollup_quantity_editable" [disabled]="!canEditOptions" class="slide-toggle-btn" color="primary"></mat-slide-toggle>
      </div>
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['rollup_formula']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="rollup_formula"
        label="Rollup formula"
      />
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['quantity_rounding']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="quantity_rounding"
        data-testid="bid-item-quantity-rounding"
        hint="Decimal places (0 to 10). Blank uses the default rounding."
        label="Quantity rounding"
        maxLength="2"
      />
    </ng-container>
    <ng-template #optionsView>
      <div *ngIf="isOrgAdmin" class="toggle-row mb-[40px]">
        <div class="label text-type-13 uppercase">Record by Station</div>
        <mat-slide-toggle formControlName="record_by_station" [disabled]="!canEditOptions" class="slide-toggle-btn" color="primary"></mat-slide-toggle>
      </div>
      <div class="toggle-row mb-[40px]">
        <div class="label text-type-13 uppercase">Rollup Qty Editable</div>
        <mat-slide-toggle formControlName="rollup_quantity_editable" [disabled]="!canEditOptions" class="slide-toggle-btn" color="primary"></mat-slide-toggle>
      </div>
      <app-view-field class="w-full mb-[40px]" [value]="form?.controls?.rollup_formula?.value" label="Rollup formula" />
      <app-view-field class="w-full mb-[40px]" [value]="form?.controls?.quantity_rounding?.value" label="Quantity rounding" />
    </ng-template>
  </div>
  <div *ngIf="canEditOptions" class="action-section w-full flex justify-between items-center gap-[10px] mt-[40px]">
    <app-primary-button (handleClick)="submit()" [isDisabled]="!isFormDirty" class="w-full">
      Submit
    </app-primary-button>
  </div>
</div>
